export enum EAdminRole {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
  COMPLIANCE = 'compliance',
  SALES = 'sales',
  FINANCE = 'finance',
  SUPPORT = 'support',
}

export type TBaseAdminData = {
  login: string;
  password: string;
  role: string;
  name: string;
  telegramId: string;
};

export type TAdminData = Omit<TBaseAdminData, 'password'> & {
  id: string;
  telegramId: string | null;
  name: string | null;
  isOnline: boolean;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type TUpdateAdminData = {
  name?: string;
  telegramId?: string;
  isActive?: boolean;
  role?: string;
  password?: string;
};
